export enum Color {
  // BASE
  White = '#FFF',
  Black = '#000',

  // GREY
  Grey50 = '#F7F8F8',
  Grey100 = '#EDEEF1',
  Grey150 = '#E3E5E9',
  Grey200 = '#D8DBDF',
  Grey300 = '#B6BAC3',
  Grey400 = '#8E95A2',
  Grey500 = '#6B7280',
  Grey600 = '#5B616E',
  Grey700 = '#4A4E5A',
  Grey800 = '#40444C',
  Grey900 = '#383A42',
  Grey950 = '#25272C',

  // LAVENDER
  Lavender50 = '#F0F4FE',
  Lavender100 = '#DDE6FC',
  Lavender200 = '#C2D4FB',
  Lavender300 = '#99B9F7',
  Lavender400 = '#6894F2',
  Lavender500 = '#3A66EB',
  Lavender600 = '#2F50E1',
  Lavender700 = '#273DCE',
  Lavender800 = '#2633A7',
  Lavender900 = '#243084',
  Lavender950 = '#1A2051',

  // GREEN
  Green50 = '#E0F6EA',
  Green100 = '#C9EEDA',
  Green200 = '#9ADFB9',
  Green300 = '#63D198',
  Green400 = '#42C37B',
  Green500 = '#25BA66',
  Green600 = '#20A159',
  Green700 = '#198447',
  Green800 = '#0F5F35',
  Green900 = '#074629',
  Green950 = '#003725',

  // RED
  Red50 = '#FFF3F1',
  Red100 = '#FFE4DF',
  Red200 = '#FFCEC5',
  Red300 = '#FFAB9C',
  Red400 = '#FF7A63',
  Red500 = '#FF5032',
  Red600 = '#F04325',
  Red700 = '#C9280C',
  Red800 = '#A6240E',
  Red900 = '#892412',
  Red950 = '#4B0E02',

  // YELLOW
  Yellow50 = '#FEFCE8',
  Yellow100 = '#FFFAC2',
  Yellow200 = '#FFF389',
  Yellow300 = '#FFE545',
  Yellow400 = '#FCD113',
  Yellow500 = '#ECB806',
  Yellow600 = '#CC9D30',
  Yellow700 = '#A17827',
  Yellow800 = '#67481B',
  Yellow900 = '#513516',
  Yellow950 = '#423913',

  // PURPLE
  Purple50 = '#F6F5FD',
  Purple100 = '#EEECFB',
  Purple200 = '#E0DCF8',
  Purple300 = '#C7BFF3',
  Purple400 = '#AB9BEA',
  Purple500 = '#8E72E0',
  Purple600 = '#835CD6',
  Purple700 = '#6C41C0',
  Purple800 = '#5B36A1',
  Purple900 = '#4C2E84',
  Purple950 = '#2F1C59',

  // PINK
  Pink50 = '#FFF4FE',
  Pink100 = '#FFE8FE',
  Pink200 = '#FEC3F9',
  Pink300 = '#FCABF1',
  Pink400 = '#FA78E8',
  Pink500 = '#F045D6',
  Pink600 = '#D425B6',
  Pink700 = '#B01B93',
  Pink800 = '#901878',
  Pink900 = '#751A60',
  Pink950 = '#4E043D',

  // MAGENTA
  Magenta50 = '#FEF2F4',
  Magenta100 = '#FDE6E9',
  Magenta200 = '#FBD0D8',
  Magenta300 = '#F8A9B8',
  Magenta400 = '#F37993',
  Magenta500 = '#EA5377',
  Magenta600 = '#D5295B',
  Magenta700 = '#B31D4B',
  Magenta800 = '#961B45',
  Magenta900 = '#811A41',
  Magenta950 = '#48091F',

  // ORANGE
  Orange50 = '#FFF9EB',
  Orange100 = '#FFEDC6',
  Orange200 = '#FFD888',
  Orange300 = '#FFC45A',
  Orange400 = '#FFA620',
  Orange500 = '#F98107',
  Orange600 = '#DD5C02',
  Orange700 = '#B73D06',
  Orange800 = '#942E0C',
  Orange900 = '#7A280D',
  Orange950 = '#461202',

  // LIME
  Lime50 = '#F1FCE9',
  Lime100 = '#E0F8CF',
  Lime200 = '#C1F2A1',
  Lime300 = '#9CE86E',
  Lime400 = '#79D942',
  Lime500 = '#59BF23',
  Lime600 = '#429818',
  Lime700 = '#347417',
  Lime800 = '#2D5C18',
  Lime900 = '#284E19',
  Lime950 = '#112B08',

  // CYAN
  Cyan50 = '#F1FAFE',
  Cyan100 = '#E2F3FC',
  Cyan200 = '#BEE8F9',
  Cyan300 = '#85D6F4',
  Cyan400 = '#3ABEEB',
  Cyan500 = '#1CAADB',
  Cyan600 = '#0E89BB',
  Cyan700 = '#0D6D97',
  Cyan800 = '#0F5D7D',
  Cyan900 = '#124D68',
  Cyan950 = '#0C3145',
}
